import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, masterOnly = false }) {
  const { status, isMaster } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[var(--aurion-bg)] text-[var(--aurion-muted)]">
        <Loader2 className="mr-2 h-4 w-4 animate-spin" />
        Checking session…
      </div>
    );
  }
  if (status !== "authed") {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (masterOnly && !isMaster) {
    return <Navigate to="/desk" replace />;
  }
  return children;
}
